module.exports = __webpack_public_path__ + "static/media/league-manager-icon.2069f942.png";